import InsightsVideoFeedbackCard from 'components/InsightsVideoFeedbackCard/InsightsVideoFeedbackCard'

export default InsightsVideoFeedbackCard
